import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-29238410"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_base_input = _resolveComponent("base-input");
    return (_openBlock(), _createBlock(_component_base_input, {
        id: _ctx.id,
        name: _ctx.name,
        modelValue: _ctx.passwordValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.passwordValue) = $event)),
        label: _ctx.label,
        placeholder: _ctx.placeholder,
        disabled: _ctx.disabled,
        readonly: _ctx.readonly,
        rules: _ctx.rule,
        "input-type": _ctx.inputFieldType,
        errors: _ctx.errors,
        onChanged: _ctx.handleChangedEvent
    }, {
        inputAppend: _withCtx((slotProps) => [
            _createElementVNode("div", {
                class: _normalizeClass(["passwordAction justify-content-center align-items-center pr-2 pl-2 bg-white", {
                        'is-invalid': !slotProps.meta.valid,
                        'is-valid': slotProps.meta.valid,
                        'was-validated': slotProps.meta.validated,
                    }]),
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.toggleShowPassword && _ctx.toggleShowPassword(...args)))
            }, [
                _createElementVNode("img", {
                    src: _ctx.passwordActionImage,
                    alt: _ctx.passwordActionTitle
                }, null, 8, _hoisted_1)
            ], 2)
        ]),
        _: 1
    }, 8, ["id", "name", "modelValue", "label", "placeholder", "disabled", "readonly", "rules", "input-type", "errors", "onChanged"]));
}
